<body>
  <div class="grid-overlay">
    <app-page-header></app-page-header>

    <div class="reports-data">
      <div> <h1>{{ 'listFailedPayment.title' | translate }}</h1></div>
      <mat-accordion>
        <mat-expansion-panel [expanded]="isOpenSearchPanel" (opened)="openSearchPanel(true)" [hideToggle]="true">
          <mat-expansion-panel-header>

            <button class="btn-icon btn"  title="{{ 'listFailedPayment.search.title' | translate }}" type="button">
              <i class="material-icons">search</i>
            </button>
          </mat-expansion-panel-header>

          <form>
            <fieldset class="fieldset">



              <div fxLayout="row wrap" class="fild_search">

                <div fxFlex="100" fxFlex.gt-xs="33" class="pr-16">
                  <div class="pb-16">
                    <mat-form-field appearance="fill">
                      <mat-label>{{ 'listFailedPayment.search.services' | translate }}</mat-label>
                      <mat-select [multiple]="true" [(value)]="selectedServices" (selectionChange)="onServiceSelectionChange($event.value)">
                        <mat-option [value]="'selectAll'">{{ 'listFailedPayment.search.selectAll' | translate }}</mat-option>
                        @for (service of services; track service) {
                          <mat-option [value]="service.id">{{ service.name_service }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>

                  </div>
                </div>

                <div fxFlex="100" fxFlex.gt-xs="33" class="pr-16">
                  <div class="pb-16">

                    <mat-form-field appearance="fill">
                      <mat-label>{{ 'listFailedPayment.search.plans' | translate }}</mat-label>
                      <mat-select [multiple]="true" [(value)]="selectedPlans" (selectionChange)="onPlanSelectionChange($event.value)">
                        <mat-option [value]="'selectAll'">{{ 'listFailedPayment.search.selectAll' | translate }}</mat-option>
                        @for (plan of plansByService; track plan) {
                          <mat-option [value]="plan.id">{{ plan.name_plan }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>

                  </div>
                </div>

                <div fxFlex="100" fxFlex.gt-xs="33" class="pr-16">
                  <div class="pb-16">

                    <mat-form-field appearance="fill" class="w-100">
                      <mat-label>{{ 'listFailedPayment.search.firstName' | translate }}</mat-label>
                      <input matInput [(ngModel)]="filter.firstName" name="firstName" />
                    </mat-form-field>

                  </div>
                </div>

                <div fxFlex="100" fxFlex.gt-xs="33" class="pr-16">
                  <div class="pb-16">

                    <mat-form-field appearance="fill" class="w-100">
                      <mat-label>{{ 'listFailedPayment.search.lastName' | translate }}</mat-label>
                      <input matInput [(ngModel)]="filter.lastName" name="lastName" />
                    </mat-form-field>

                  </div>
                </div>

                <div fxFlex="100" fxFlex.gt-xs="33" class="pr-16">
                  <div class="pb-16">

                    <mat-form-field appearance="fill" class="w-100">
                      <mat-label>{{ 'listFailedPayment.search.code' | translate }}</mat-label>
                      <input matInput [(ngModel)]="filter.code" name="code" />
                    </mat-form-field>

                  </div>
                </div>

                <div fxFlex="100" fxFlex.gt-xs="33" class="pr-16">
                  <div class="pb-16">

                    <mat-form-field appearance="fill" class="w-100">
                      <mat-label>{{ 'listFailedPayment.search.email' | translate }}</mat-label>
                      <input matInput [(ngModel)]="filter.email" name="email" />
                    </mat-form-field>
                  </div>
                </div>


              </div>

            </fieldset>
            <div class="button_report_align"fxLayout="row" fxLayoutAlign="end center" >

              <button
                mat-raised-button
                type="button"
                color="warn"
                class="ml-16 mr-16 button_report light"
                (click)="reset()"
                >
                <mat-icon>refresh</mat-icon>
              </button>

              <button
                mat-raised-button
                type="button"
                color="primary"
                class="ml-16 button_report blue"
                [disabled]="!canManageFailedPayments()"
                (click)="search()">
                <mat-icon>search</mat-icon>
              </button>

              <!--                        <button-->
              <!--                                mat-raised-button-->
              <!--                                type="button"-->
              <!--                                color="primary"-->
              <!--                                class="ml-16 button_report blue"-->
              <!--                                (click)="download()">-->
              <!--                            <mat-icon>download</mat-icon>-->
            <!--                        </button>-->

          </div>
        </form>
      </mat-expansion-panel>
    </mat-accordion>

    <div style="padding-top: 2em;">
      <mat-table [dataSource]="dataSource"  >


        <ng-container matColumnDef="service">
          <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'listFailedPayment.table.columns.service' | translate }} </mat-header-cell>
          <mat-cell *matCellDef="let row" data-label="service"> {{row.service}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="plan">
          <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'listFailedPayment.table.columns.plan' | translate }} </mat-header-cell>
          <mat-cell *matCellDef="let row" data-label="plan"> {{row.plan}} </mat-cell>
        </ng-container>


        <ng-container matColumnDef="firstName">
          <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'listFailedPayment.table.columns.name' | translate }} </mat-header-cell>
          <mat-cell *matCellDef="let row" data-label="firstName"> {{row.firstName}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="lastName">
          <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'listFailedPayment.table.columns.lastName' | translate }} </mat-header-cell>
          <mat-cell *matCellDef="let row" data-label="lastName"> {{row.lastName}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="code">
          <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'listFailedPayment.table.columns.code' | translate }} </mat-header-cell>
          <mat-cell *matCellDef="let row" data-label="code"> {{row.code}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="email">
          <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'listFailedPayment.table.columns.email' | translate }} </mat-header-cell>
          <mat-cell *matCellDef="let row" data-label="email"> {{row.email}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="dateLastInvoice">
          <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'listFailedPayment.table.columns.lastAttempt' | translate }} </mat-header-cell>
          <mat-cell *matCellDef="let row" data-label="dateLastInvoice"> {{row.dateLastInvoice}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'listFailedPayment.table.columns.actions' | translate }} </mat-header-cell>
          <mat-cell *matCellDef="let row" data-label="estatus">
            @if (canManageFailedPayments()) {
              <button mat-icon-button [matMenuTriggerFor]="msgMenu" (click)="$event.stopPropagation()" class="hidden-on-open">
                <mat-icon class="text-muted">more_vert</mat-icon>
              </button>
            }
            <mat-menu style="width: 200px;" #msgMenu="matMenu">
              <button mat-menu-item (click)="reactivateItem(row)"  class="menu_report"><img src="../assets/icons/toggle.svg">  {{ 'listFailedPayment.table.menu.reactivate' | translate }} </button>
            </mat-menu>
          </mat-cell>
        </ng-container>



        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" >
        </mat-row>
      </mat-table>
      <mat-paginator [length]="tableService.pager.totalEntities || 0"
        [pageSize]="tableService.pager.pageSize"
        [pageIndex]="tableService.pager.pageIndex"
        [pageSizeOptions]="[5, 10, 20, 50]"
        (page)="list($event)">
      </mat-paginator>
    </div>


  </div>
  <div class="options-buttons">
    <button class="back-btn" (click)="goBack()" >{{ 'listFailedPayment.buttons.back' | translate }}</button>
  </div>
</div>
</body>
